module.exports = __webpack_public_path__ + "img/3_Card_color_horizontal.141a94e5.png";